import styled from 'styled-components';

export const MainViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  height: 100%;
  width: 100%;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px 0 0 24px;
  max-width: 600px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const RightContainer = styled.div`
  display: flex;
  max-width: 500px;
  max-height: calc(100vh - 200px);
`;

export const StyledImage = styled.img`
  width: 100%;
  margin-top: 20px;
`;

export const MainUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`;

export const UploadContent = styled.div`
  margin: 0 20px 0 15px;
  flex: 1;
`;

export const MainUploadRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  flex: 1;
  align-self: stretch;
`;

export const UploadSideBar = styled.div`
  width: 180px;
`;

export const UPLOAD_LEFT_CONTAINER_WIDTH = 280;
